(function ($, window, document) {
	var $win = $(window);
	var $doc = $(document);
	var $body = $('body');
	const $html = $('html');
	const $header = $('.js-header');
	const $headerHolder = $('.js-header-holder');
	const $footer = $('.js-footer');
	let windowWidth = $win.outerWidth();

	$win.scrollTop(0);

	// headerHolderHeight();
	// heroSectionHeight();

	const breakpointMobile = window.matchMedia('(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)');

	/**
	 * Handler to trigger "widthResize" event when the width of the element changes.
	 * // iOs device window resize helper
	 */
	$.event.special.widthResize = {
		setup: function () {
			const $this = $(this);
			$this.data('currentWidth', $this.width());

			$this.on('resize.widthResize', function () {
				const newWidth = $this.width();
				const prevWidth = $this.data('currentWidth');

				if (newWidth !== prevWidth) {
					$this.data('currentWidth', newWidth).trigger('widthResize');
				}
			});
		},
		teardown: function () {
			$(this).off('resize.widthResize');
		}
	};

	function window_width() {
		var myWidth = 0;
		if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth;
		else if (document.body && document.body.clientWidth)
			myWidth = document.body.clientWidth;
		return myWidth;
	}

	function window_height() {
		var myHeight = 0;
		if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight;
		else if (document.body && document.body.clientHeight)
			myHeight = document.body.clientHeight;
		return myHeight;
	}

	//handle videos
	function initHeroMedia() {
		const $heroLinks = $('.js-hero-link');
		const $heroMediaSlides = $(".hero__media-slide");

		if (!$heroMediaSlides.length) {
			return;
		}

		$heroMediaSlides.each(function (slideIndex, heroMediaSlide) {
			const $heroMediaSlide = $(heroMediaSlide);
			const containerId = '#' + $heroMediaSlide.attr('id');

			const $heroVideo = $heroMediaSlide.find('.js-hero-player');
			let heroPlyr = null;

			if ($heroVideo.length) {
				const plyrSettings = {
					volume: 0,
					muted: true,
					playsinline: true,
					clickToPlay: false,
					controls: false,
					vimeo: {
						background: true
					},
					loop: {
						active: true,
					},
				}

				if (slideIndex === 0) {
					plyrSettings.autoplay = true;
				}

				heroPlyr = new Plyr($heroVideo, plyrSettings);
			}

			$heroLinks.on('mouseover', function () {
				if ($win.outerWidth() < 1024) {
					return;
				}

				const targetId = $(this).data('target');

				if (targetId === containerId) {
					$heroMediaSlide.addClass('is-active');
					if (heroPlyr) {
						heroPlyr.play();
					}
				} else {
					$heroMediaSlide.removeClass('is-active');
					if (heroPlyr) {
						heroPlyr.pause();
					}
				}
			});

			$win.on('resize', function () {
				if ($win.outerWidth() >= 1024) {
					return;
				}

				if (slideIndex === 0) {
					$heroMediaSlide.addClass('is-active');
					if (heroPlyr) {
						heroPlyr.play();
					}
				} else {
					$heroMediaSlide.removeClass('is-active');
					if (heroPlyr) {
						heroPlyr.pause();
					}
				}
			});
		});
	}

	function playPlyr(videoElement, plyrSettings) {
		const plyr = new Plyr(videoElement, plyrSettings);

		plyr.once('ready', () => {
			plyr.elements.container.classList.add('auto-paused');
			playVideoObserver.observe(plyr.elements.container);
		});

		let playVideoObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				const videoContainer = entry.target;
				if (entry.isIntersecting) {
					if (videoContainer.classList.contains('auto-paused')) {
						videoContainer.classList.remove('auto-paused');
						plyr.play();
					}
				} else {
					if (plyr.playing) {
						videoContainer.classList.add('auto-paused');
						plyr.pause();
					}
				}
			});
		});
	}

	function loadPlyr(videoElement, plyrSettings) {
		let loadVideoObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (video) {
				if (video.isIntersecting) {
					if (video.target instanceof HTMLVideoElement) {
						for (let source in video.target.children) {
							let videoSource = video.target.children[source];
							if (
								typeof videoSource.tagName === "string" &&
								videoSource.tagName === "SOURCE"
							) {
								videoSource.src = videoSource.dataset.src;
							}
						}

						video.target.load();
					}

					loadVideoObserver.unobserve(video.target);
					playPlyr(video.target, plyrSettings);
				}
			});
		});

		loadVideoObserver.observe(videoElement);
	}

	function initPlyrs() {
		let videoElements = document.querySelectorAll(".js-auto-player");

		videoElements.forEach(function (videoElement) {
			let plyrSettings = {
				muted: true,
				autoplay: false,
				autopause: false,
				clickToPlay: false,
				fullscreen: { enabled: false },
				controls: [],
				loop: {
					active: true,
				},
				storage: {
					enabled: false,
				}
			}

			if (videoElement.classList.contains('player-allow-pause')) {
				plyrSettings.controls.push('play');
			}

			if (videoElement.classList.contains('player-allow-unmute')) {
				plyrSettings.controls.push('mute');
			} else {
				plyrSettings.vimeo = { background: true }
			}

			loadPlyr(videoElement, plyrSettings);
		});
	}

	/*  scroll to functionality  */

	$('.js-scroll-to').on('click', function (event) {
		event.preventDefault();

		const $this = $(this);
		const $dataTo = $this.data("target");
		const $target = "#" + $dataTo;

		if ($target.length) {
			const $targetNewOffset = $(`${$target}`).offset().top;

			scrollTo($targetNewOffset, 1000);
		};
	});

	function scrollTo(ScrollTop, speed) {
		$('html, body').animate({
			scrollTop: ScrollTop,
		}, speed);
	}

	/**
	 * Init Slider
	 */

	function handleSliders() {
		$('.js-slider .swiper').each(function (index, slider) {
			const $this = $(this);

			// Dont init slider if it has less than 2 slides
			const $sliderSlides = $this.find('.slider__slide');
			if($sliderSlides.length < 2) {
				return;
			}

			const $sliderContainer = $this.parent();

			const prevEl = $sliderContainer.find('.swiper-button-prev')[0];
			const nextEl = $sliderContainer.find('.swiper-button-next')[0];
			const paginationEl = $sliderContainer.find('.swiper-pagination')[0];

			const autoHeightSlider = !$sliderContainer.hasClass('slider--hero');

			const swiper = new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				rewind: false,
				autoHeight: autoHeightSlider,
				navigation: {
					nextEl,
					prevEl,
				},
				pagination: {
					el: paginationEl,
					type: 'fraction',
				},
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				speed: 500,
			});
		});
	};

	/**
	 * Handle missing slider image sizes
	 */

	$('.swiper-slide').each(function () {
		let hideMobile = $(this).hasClass('remove-mobile');
		let hideDesktop = $(this).hasClass('remove-desktop');

		if (breakpointMobile.matches && hideMobile) {
			$(this).remove();
		}

		if (!breakpointMobile.matches && hideDesktop) {
			$(this).remove();
		}
	})

	function isTouchDevice() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	}

	const cursor = $('.cursor');

	$win.on('mousemove', updateCursorPosition);

	$doc.on('mousemove', updateCursorPosition);

	function updateCursorPosition(e) {
		cursor.css({
			left: e.clientX,
			top: e.clientY,
		});
	}

	const sliders = $('.js-slider');

	sliders.each(function () {
		$this = $(this);
		
		$this.on('mouseover', '.swiper-button-next', function (event) {
			if (!isTouchDevice()) {
				$('.cursor').addClass('on-slider');
			}
		});

		$this.on('mouseleave', '.swiper-button-next', function (event) {
			$('.cursor').removeClass('on-slider');
		});

		$this.on('mouseover', '.swiper-button-prev', function (event) {
			if (!isTouchDevice()) {
				$('.cursor').addClass('is-prev');
				$('.cursor').addClass('on-slider');
			}
		});

		$this.on('mouseleave', '.swiper-button-prev', function (event) {
			$('.cursor').removeClass('is-prev');
			$('.cursor').removeClass('on-slider');
		});
	})


	/**
	 * Handle Open More
	 */

	function openMore() {
		const infoSections = $('.js-more-info-section');
		if (infoSections != null) {

			infoSections.each(function (element, index) {
				const elHolder = $(this);
				const trigger = elHolder.find('.js-open-more-info-trigger');
				const infoHolder = elHolder.find('.js-more-info-holder');
				const elsInHolder = infoHolder.find('>');
				let showElsCount = 0;

				if (breakpointMobile.matches) {

					showElsCount = elHolder.attr('data-show-mobile');
				} else {

					showElsCount = elHolder.attr('data-show-desktop');
				};

				if (!breakpointMobile.matches && elsInHolder.length <= showElsCount) {

					trigger.addClass('is-hidden');
				} else {
					trigger.removeClass('is-hidden');
				};

				elsInHolder.each(function (el, index) {
					const elem = $(this);

					if (elem.index() >= showElsCount && !trigger.hasClass('is-open')) {
						elem.stop().slideUp();
					} else {
						elem.stop().slideDown();
					};
				});
			});
		};
	};

	$('.js-open-more-info-trigger').on('click', function (e) {
		e.preventDefault();

		const $this = $(this);
		const infoSections = $this.closest('.js-more-info-section');
		let showElsCount = 0;

		if (breakpointMobile.matches) {

			showElsCount = infoSections.attr('data-show-mobile');
		} else {

			showElsCount = infoSections.attr('data-show-desktop');
		};

		const infoHolder = infoSections.find('.js-more-info-holder');
		const elsInHolder = infoHolder.find('>');

		elsInHolder.each(function (el, index) {
			const elem = $(this);

			if (elem.index() >= showElsCount) {
				elem.slideToggle();
			};
		});

		$this.toggleClass('is-open');
	});


	/**
	 * Handle navigation
	 */

	$('.js-nav-trigger').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);

		$this.toggleClass('is-open');
		$('body').toggleClass('is-open');
		$header.toggleClass('is-open');
		$('.js-nav-holder').toggleClass('is-open');
		$footer.toggleClass('is-fixed');
		$('.js-subscribe').toggleClass('is-white');

		const $footerHeight = $footer.outerHeight(true);
	});


	$('.nav-close').on('click', function (e) {
		e.preventDefault();
		$('.js-nav-trigger').trigger('click');
	});

	/**
	 * Handle footer popup
	 */

	$('.js-footer-popup-trigger').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);

		$this.toggleClass('is-open');
		$footer.toggleClass('is-open');

		const $footerHeight = $footer.outerHeight(true);
		$('.footer__popup').css('--footer-height', $footerHeight + 'px');
	});

	$('.js-footer-close').on('click', function (e) {
		e.preventDefault();

		$footer.removeClass('is-open');
		$('.js-footer-popup-trigger').removeClass('is-open');
	});

	/**
	 * handle form opening
	 */

	$('.js-subscribe > a').on(' click', function (e) {
		e.preventDefault();
		const $this = $(this);

		$this.addClass('is-open');
		$this.parent().addClass('is-open');

		$this.parent().find('.subscribe__form').addClass('is-open');
	});

	let inputVal;
	let inputValAlt;

	$('.js-subscribe .gform_button').on('click', function (e) {
		inputVal = $('.js-subscribe').find('input[type="email"]').val();
	});

	$('.js-subscribe-alt .gform_button').on('click', function (e) {
		inputValAlt = $('.js-subscribe-alt').find('input[type="email"]').val();
	});

	$('.js-subscribe-alt input[type="email"]').on('focus', function (e) {
		const $this = $(this);

		$this.closest('.js-subscribe-alt').addClass('is-active');
	});

	$('.js-subscribe-alt input[type="email"]').on('focusout', function () {
		const $this = $(this);

		if ($this.val() === "") {

			$this.closest('.js-subscribe-alt').removeClass('is-active');
		};
	});

	jQuery(document).bind('gform_confirmation_loaded', function (event, formId) {
		if (formId == 1) {
			const subscribeForm = $('.js-subscribe');
			const subscribeText = subscribeForm.find('.subscribe__meta');

			subscribeForm.addClass('is-confirmed');
			subscribeText.text(inputVal);

			const $footerHeight = $footer.outerHeight();

			$('.js-nav-holder').css('--footer-height', $footerHeight + 'px');
		} else if (formId == 4) {
			const subscribeForm = $('.js-subscribe-alt');
			const subscribeText = subscribeForm.find('.subscribe__meta');

			subscribeForm.addClass('is-confirmed');
			subscribeText.text(inputValAlt);
		};
	});

	/**
	 * Fixed header
	 */

	function fixedHeader() {
		const scrollTop = $win.scrollTop();
		let $headerHeight = $header.outerHeight();
		const holderPos = $headerHolder.offset().top;
		const holderFullPos = $headerHeight + holderPos;
		let viewPortConst = $win.outerHeight() * 10 / 100;

		if (scrollTop > holderFullPos + viewPortConst) {
			$header.addClass('is-fixed');
		} else {
			$header.removeClass('is-fixed');
			updateCssVariables();
		};

		if (scrollTop > holderFullPos) {
			$header.addClass('is-under-holder');
		} else {
			$header.removeClass('is-under-holder');
		};
	};

	/**
	 * Hero login animation
	 */

	function loadHeroAnim() {
		const $heroLoader = $('.js-hero');
		const delayStep = 0.5;

		if ($('.js-hero') != null) {

			const firstLinks = $heroLoader.find('.hero__entry-brand');
			const secondLinks = $heroLoader.find('.hero__entry-links');

			firstLinks.removeClass('not-visible');

			[...document.querySelectorAll('.hero__entry-brand li')].forEach((row, i) => {

				$(row).css('opacity', 0);

				$(row).css({
					animationDelay: `${(i) * delayStep}s`,
				}).addClass('anim-in');
			});

			firstLinks.find('li').last().on('animationend', () => {
				setTimeout(function () {
					firstLinks.addClass('not-visible');
				}, 400);

				setTimeout(function () {
					firstLinks.addClass('visually-hidden');
					secondLinks.addClass('not-hidden');

					[...document.querySelectorAll('.hero__entry-links li')].forEach((row, i) => {

						$(row).css('opacity', 0);

						$(row).css({
							animationDelay: `${(i) * delayStep}s`,
						}).addClass('anim-in');
					});

					secondLinks.find('li').last().on('animationend', () => {
						$heroLoader.addClass('is-animated');
					});
				}, 600);
			});
		};
	};


	/**
	 * open card info
	 */

	$('.js-card-info-trigger').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);

		$this.toggleClass('is-open');
		$this.parent().find('.card__info').slideToggle();
	});


	/**
	 * Set cookie.
	 */
	const setCookies = (name, value) => {
		document.cookie = name + '=' + (value || '') + '; path=/';
	};


	/**
	 * Get cookie data.
	 */
	const getCookies = (name) => {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}

		return null;
	};

	/**
	 * Erase cookie value
	  */
	// const eraseCookies = (name) => {
	// 	document.cookie = name + '=; Max-Age=-99999999';
	// };


	// this is for cookie on event
	const revisitingUser = getCookies('revisitingUser');

	if (revisitingUser !== null) {
		if ($('.hero').length) {
			document.querySelector('.hero').classList.remove('js-hero');
		}
	} else {
		setCookies('revisitingUser', 'true');
	}

	function updateCssVariables() {
		if (!$header.hasClass('is-fixed')) {
			$html.css('--header-height', $header.outerHeight() + 'px');
		}

		$html.css('--footer-height', $footer.outerHeight() + 'px');
	}

	initHeroMedia();
	initPlyrs();

	$win.on('load', function () {
		loadHeroAnim();
		openMore();
	});

	$win.on('load widthResize', function () {
		handleSliders();
	});

	$win.on('resize', function () {
		if ($win.width() != windowWidth) {
			windowWidth = $win.width();
			openMore();
		};
	});

	$win.on('load scroll', function () {
		fixedHeader();
	});

	updateCssVariables();

	$win.on('widthResize', function () {
		updateCssVariables();
	});
})(jQuery, window, document);
